import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const lightTheme: OctopusTheme = {
    "colorAvatarBackgroundImageDefault": globals["colorScales"]["navy"]["200"],
    "colorAvatarBackgroundImageHover": globals["colorScales"]["navy"]["300"],
    "colorAvatarBackgroundProjectDefault": globals["colorScales"]["navy"]["500"],
    "colorAvatarBackgroundProjectHover": globals["colorScales"]["navy"]["600"],
    "colorAvatarBackgroundSpaceDefault": globals["colorScales"]["blue"]["500"],
    "colorAvatarBackgroundSpaceHover": globals["colorScales"]["blue"]["600"],
    "colorAvatarBackgroundTemplateDefault": globals["colorScales"]["navy"]["100"],
    "colorAvatarBackgroundTemplateHover": globals["colorScales"]["navy"]["200"],
    "colorAvatarBackgroundTenantDefault": globals["colorScales"]["white"],
    "colorAvatarBackgroundTenantHover": globals["colorScales"]["navy"]["100"],
    "colorAvatarBackgroundUserDefault": globals["colorScales"]["blue"]["500"],
    "colorAvatarBackgroundUserHover": globals["colorScales"]["blue"]["600"],
    "colorAvatarIconPrimary": globals["colorScales"]["white"],
    "colorAvatarIconSecondary": globals["colorScales"]["navy"]["800"],
    "colorAvatarStackBackgroundHover": globals["colorScales"]["blue"]["200"],
    "colorAvatarStackBorder": globals["colorScales"]["white"],
    "colorAvatarText": globals["colorScales"]["white"],
    "colorBackgroundBold": globals["colorScales"]["white"],
    "colorBackgroundDanger": globals["colorScales"]["red"]["100"],
    "colorBackgroundDisabled": globals["colorScales"]["slate"]["200"],
    "colorBackgroundFeature": globals["colorScales"]["purple"]["100"],
    "colorBackgroundInfo": globals["colorScales"]["blue"]["100"],
    "colorBackgroundInverseNeutral": globals["colorScales"]["slate"]["600"],
    "colorBackgroundInversePrimary": globals["colorScales"]["slate"]["900"],
    "colorBackgroundInverseSecondary": globals["colorScales"]["slate"]["700"],
    "colorBackgroundInverseSuccess": globals["colorScales"]["green"]["500"],
    "colorBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorBackgroundPrimaryHover": globals["colorScales"]["slate"]["100"],
    "colorBackgroundPrimaryPressed": globals["colorScales"]["slate"]["200"],
    "colorBackgroundPrimaryTransparent": "rgb(from #FFFFFF r g b / 0.72)",
    "colorBackgroundQuartaryDefault": globals["colorScales"]["white"],
    "colorBackgroundQuartaryHover": globals["colorScales"]["slate"]["100"],
    "colorBackgroundQuartaryPressed": globals["colorScales"]["slate"]["200"],
    "colorBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorBackgroundSecondaryHover": globals["colorScales"]["white"],
    "colorBackgroundSecondaryPressed": globals["colorScales"]["slate"]["300"],
    "colorBackgroundSecondaryTransparent": "rgb(from #F5F6F8 r g b / 0.72)",
    "colorBackgroundSelected": globals["colorScales"]["blue"]["500"],
    "colorBackgroundSuccess": globals["colorScales"]["green"]["100"],
    "colorBackgroundTertiary": globals["colorScales"]["slate"]["200"],
    "colorBackgroundWarning": globals["colorScales"]["yellow"]["100"],
    "colorBadgeBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorBadgeBackgroundFeature": globals["colorScales"]["purple"]["200"],
    "colorBadgeBackgroundInfo": globals["colorScales"]["blue"]["500"],
    "colorBadgeBackgroundInverseNeutral": globals["colorScales"]["slate"]["600"],
    "colorBadgeBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorBadgeBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorBadgeBackgroundUpsell": globals["colorScales"]["purple"]["200"],
    "colorBadgeBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorBadgeIconFeature": globals["colorScales"]["purple"]["700"],
    "colorBadgeIconPrimary": globals["colorScales"]["white"],
    "colorBadgeIconSecondary": globals["colorScales"]["black"],
    "colorBadgeIconUpsell": globals["colorScales"]["purple"]["700"],
    "colorBadgeTextFeature": globals["colorScales"]["purple"]["700"],
    "colorBadgeTextPrimary": globals["colorScales"]["white"],
    "colorBadgeTextSecondary": globals["colorScales"]["black"],
    "colorBadgeTextUpsell": globals["colorScales"]["purple"]["700"],
    "colorBorderBold": globals["colorScales"]["slate"]["500"],
    "colorBorderDanger": globals["colorScales"]["red"]["500"],
    "colorBorderDefault": globals["colorScales"]["slate"]["600"],
    "colorBorderDisabled": globals["colorScales"]["slate"]["300"],
    "colorBorderFeature": globals["colorScales"]["purple"]["500"],
    "colorBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorBorderInversePrimary": globals["colorScales"]["slate"]["700"],
    "colorBorderInverseSecondary": globals["colorScales"]["slate"]["700"],
    "colorBorderLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorBorderLinkHover": globals["colorScales"]["blue"]["600"],
    "colorBorderPrimary": globals["colorScales"]["slate"]["200"],
    "colorBorderSecondary": globals["colorScales"]["slate"]["100"],
    "colorBorderSelected": globals["colorScales"]["blue"]["500"],
    "colorBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorBorderTertiary": globals["colorScales"]["slate"]["300"],
    "colorBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorButtonBackgroundDestructiveDefault": globals["colorScales"]["red"]["500"],
    "colorButtonBackgroundDestructiveHover": globals["colorScales"]["red"]["600"],
    "colorButtonBackgroundDestructivePressed": globals["colorScales"]["red"]["700"],
    "colorButtonBackgroundDisabled": "rgb(from #DEE1E6 r g b / 0.56)",
    "colorButtonBackgroundLoudDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonBackgroundLoudHover": globals["colorScales"]["blue"]["600"],
    "colorButtonBackgroundLoudPressed": globals["colorScales"]["blue"]["700"],
    "colorButtonBackgroundNeutralDefault": globals["colorScales"]["slate"]["100"],
    "colorButtonBackgroundNeutralHover": globals["colorScales"]["slate"]["200"],
    "colorButtonBackgroundNeutralPressed": globals["colorScales"]["slate"]["300"],
    "colorButtonBackgroundPrimaryDefault": globals["colorScales"]["green"]["500"],
    "colorButtonBackgroundPrimaryHover": globals["colorScales"]["green"]["600"],
    "colorButtonBackgroundPrimaryPressed": globals["colorScales"]["green"]["700"],
    "colorButtonBackgroundQuietDefault": "rgb(from #1A77CA r g b / 0)",
    "colorButtonBackgroundQuietHover": "rgb(from #1A77CA r g b / 0.08)",
    "colorButtonBackgroundQuietPressed": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBackgroundSecondaryDefault": "rgb(from #1A77CA r g b / 0)",
    "colorButtonBackgroundSecondaryHover": "rgb(from #1A77CA r g b / 0.08)",
    "colorButtonBackgroundSecondaryPressed": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBackgroundTertiaryDefault": "rgb(from #1A77CA r g b / 0.06)",
    "colorButtonBackgroundTertiaryHover": "rgb(from #1A77CA r g b / 0.16)",
    "colorButtonBackgroundTertiaryPressed": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBorderDisabled": globals["colorScales"]["slate"]["200"],
    "colorButtonBorderSecondary": globals["colorScales"]["blue"]["400"],
    "colorButtonIconDestructive": globals["colorScales"]["white"],
    "colorButtonIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorButtonIconLoud": globals["colorScales"]["white"],
    "colorButtonIconNeutral": globals["colorScales"]["slate"]["800"],
    "colorButtonIconPrimary": globals["colorScales"]["white"],
    "colorButtonIconQuiet": globals["colorScales"]["blue"]["500"],
    "colorButtonIconSecondary": globals["colorScales"]["blue"]["500"],
    "colorButtonIconTertiary": globals["colorScales"]["blue"]["500"],
    "colorButtonTextDestructive": globals["colorScales"]["white"],
    "colorButtonTextDisabled": globals["colorScales"]["slate"]["400"],
    "colorButtonTextLoud": globals["colorScales"]["white"],
    "colorButtonTextNeutral": globals["colorScales"]["slate"]["800"],
    "colorButtonTextPrimary": globals["colorScales"]["white"],
    "colorButtonTextQuiet": globals["colorScales"]["blue"]["500"],
    "colorButtonTextSecondary": globals["colorScales"]["blue"]["500"],
    "colorButtonTextTertiary": globals["colorScales"]["blue"]["500"],
    "colorCalloutBackgroundDangerDefault": "rgb(from #FF9F9F r g b / 0.24)",
    "colorCalloutBackgroundDangerHover": "rgb(from #FF9F9F r g b / 0.4)",
    "colorCalloutBackgroundDangerPressed": "rgb(from #FF9F9F r g b / 0.64)",
    "colorCalloutBackgroundDefaultHover": "rgb(from #B2B9C5 r g b / 0.4)",
    "colorCalloutBackgroundDefaultPressed": "rgb(from #B2B9C5 r g b / 0.64)",
    "colorCalloutBackgroundFeatureDefault": "rgb(from #C5AEEE r g b / 0.24)",
    "colorCalloutBackgroundFeatureHover": "rgb(from #C5AEEE r g b / 0.4)",
    "colorCalloutBackgroundFeaturePressed": "rgb(from #C5AEEE r g b / 0.64)",
    "colorCalloutBackgroundInfoDefault": "rgb(from #87BFEC r g b / 0.24)",
    "colorCalloutBackgroundInfoHover": "rgb(from #87BFEC r g b / 0.4)",
    "colorCalloutBackgroundInfoPressed": "rgb(from #87BFEC r g b / 0.64)",
    "colorCalloutBackgroundSuccessDefault": "rgb(from #5ECD9E r g b / 0.24)",
    "colorCalloutBackgroundSuccessHover": "rgb(from #5ECD9E r g b / 0.4)",
    "colorCalloutBackgroundSuccessPressed": "rgb(from #5ECD9E r g b / 0.64)",
    "colorCalloutBackgroundUpsell": "linear-gradient(95deg, rgb(from #CDE4F7 r g b / 0.4) 0%, rgb(from #E7DEF8 r g b / 0.4) 100%)",
    "colorCalloutBackgroundWarningDefault": "rgb(from #FFDF62 r g b / 0.24)",
    "colorCalloutBackgroundWarningHover": "rgb(from #FFDF62 r g b / 0.4)",
    "colorCalloutBackgroundWarningPressed": "rgb(from #FFDF62 r g b / 0.64)",
    "colorCalloutBorderDanger": globals["colorScales"]["red"]["500"],
    "colorCalloutBorderDefault": globals["colorScales"]["slate"]["500"],
    "colorCalloutBorderFeature": globals["colorScales"]["purple"]["500"],
    "colorCalloutBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorCalloutBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorCalloutBorderUpsell": "linear-gradient(180deg, #87BFEC 0%, #C5AEEE 100%)",
    "colorCalloutBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorCalloutIconDanger": globals["colorScales"]["red"]["600"],
    "colorCalloutIconDefault": globals["colorScales"]["slate"]["600"],
    "colorCalloutIconFeature": globals["colorScales"]["purple"]["600"],
    "colorCalloutIconInfo": globals["colorScales"]["blue"]["600"],
    "colorCalloutIconSuccess": globals["colorScales"]["green"]["600"],
    "colorCalloutIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorCalloutTextBody": globals["colorScales"]["black"],
    "colorCalloutTextDanger": globals["colorScales"]["red"]["600"],
    "colorCalloutTextDefault": globals["colorScales"]["slate"]["600"],
    "colorCalloutTextFeature": globals["colorScales"]["purple"]["600"],
    "colorCalloutTextInfo": globals["colorScales"]["blue"]["600"],
    "colorCalloutTextSuccess": globals["colorScales"]["green"]["600"],
    "colorCalloutTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorCardBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorCardBackgroundSecondaryDefault": "rgb(from #FFFFFF r g b / 0)",
    "colorCardBackgroundSecondaryHover": "rgb(from #F5F6F8 r g b / 0.64)",
    "colorCarouselBackgroundPrimary": globals["colorScales"]["slate"]["900"],
    "colorCarouselIconDefault": "rgb(from #B2B9C5 r g b / 0.32)",
    "colorCarouselIconHover": "rgb(from #B2B9C5 r g b / 0.72)",
    "colorCarouselIconSelected": globals["colorScales"]["blue"]["400"],
    "colorCarouselTextPrimary": globals["colorScales"]["white"],
    "colorCategorySelectListBackgroundActive": "rgb(from #1A77CA r g b / 0.06)",
    "colorCategorySelectListBackgroundDefault": globals["colorScales"]["slate"]["100"],
    "colorCategorySelectListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconActive": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconDefault": globals["colorScales"]["slate"]["600"],
    "colorCategorySelectListIconHover": globals["colorScales"]["white"],
    "colorCategorySelectListTextActive": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListTextHover": globals["colorScales"]["white"],
    "colorChipBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorChipBackgroundPrimary": globals["colorScales"]["slate"]["200"],
    "colorChipBackgroundSecondary": globals["colorScales"]["slate"]["300"],
    "colorChipBackgroundSuccessful": globals["colorScales"]["green"]["500"],
    "colorChipBorderPrimary": globals["colorScales"]["slate"]["300"],
    "colorChipFilledBackgroundDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledBackgroundInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledBackgroundPrimary": globals["colorScales"]["navy"]["200"],
    "colorChipFilledBackgroundSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledBackgroundSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledBackgroundWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipFilledIconDanger": globals["colorScales"]["red"]["600"],
    "colorChipFilledIconInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledIconPrimary": globals["colorScales"]["navy"]["600"],
    "colorChipFilledIconSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledIconSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipFilledTextDanger": globals["colorScales"]["red"]["600"],
    "colorChipFilledTextInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledTextPrimary": globals["colorScales"]["navy"]["600"],
    "colorChipFilledTextSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledTextSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipIconInverse": globals["colorScales"]["white"],
    "colorChipIconPrimary": globals["colorScales"]["slate"]["800"],
    "colorChipIconWarning": globals["colorScales"]["orange"]["500"],
    "colorChipOutlinedBorderDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedBorderPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedBorderSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedBorderWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedIconDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedIconInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedIconPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedIconSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedIconSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedIconWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedTextDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedTextInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedTextPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedTextSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedTextSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedTextWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipTextInverse": globals["colorScales"]["white"],
    "colorChipTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorBackground": globals["colorScales"]["slate"]["100"],
    "colorCodeEditorCodeActivelineBackground": "rgb(from #68778D r g b / 0.15)",
    "colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeBracketCommentColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeCursorBorderLeft": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorCodeCursorBorderRight": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeErrorInvalidcharColor": globals["colorScales"]["red"]["700"],
    "colorCodeEditorCodeFatCursorBackground": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeHint": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeHintActiveBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeHintsBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeIndentationMarkerActiveColor": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeIndentationMarkerColor": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeLinenumberColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeMatchingbracketColor": globals["colorScales"]["slate"]["900"],
    "colorCodeEditorCodePositiveColor": globals["colorScales"]["green"]["800"],
    "colorCodeEditorCodePropertyColor": globals["colorScales"]["orange"]["800"],
    "colorCodeEditorCodePunctuationUnitNegativeColor": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSelectedBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeStringOperatorColor": globals["colorScales"]["green"]["700"],
    "colorCodeEditorCodeSyntaxAtom": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxAttributeName": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxBool": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxBracket": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeSyntaxClassName": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodeSyntaxComment": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeSyntaxDeleted": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxDeletedBackground": globals["colorScales"]["red"]["100"],
    "colorCodeEditorCodeSyntaxEmphasis": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxEscape": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxHeading": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxInvalid": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxKeyword": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxLink": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxMeta": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxName": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxNumber": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxOperator": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxPropertyName": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodeSyntaxQuote": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxRegexp": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxSpecialVariableName": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxString": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxStrong": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxTagName": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxTypeName": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxTypeOperator": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxUrl": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxVariableName": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeVariable2Variable3String2UrlColor": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeVariableColor": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorForeground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorSelection": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorSelectionMatch": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorTextDefault": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorTextGutter": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorTextHighlight": globals["colorScales"]["orange"]["800"],
    "colorCodeEditorTextHintHighlight": globals["colorScales"]["green"]["500"],
    "colorCodeEditorToolbarBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorToolbarButtonHover": globals["colorScales"]["slate"]["300"],
    "colorCodeReviewBackgroundDangerDefault": globals["colorScales"]["red"]["200"],
    "colorCodeReviewBackgroundDangerMuted": globals["colorScales"]["red"]["300"],
    "colorCodeReviewBackgroundPrimaryDefault": globals["colorScales"]["slate"]["100"],
    "colorCodeReviewBackgroundPrimaryMuted": globals["colorScales"]["white"],
    "colorCodeReviewBackgroundSuccessDefault": globals["colorScales"]["green"]["200"],
    "colorCodeReviewBackgroundSuccessMuted": globals["colorScales"]["green"]["300"],
    "colorCodeReviewTextDanger": globals["colorScales"]["red"]["700"],
    "colorCodeReviewTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorCodeReviewTextSuccess": globals["colorScales"]["green"]["700"],
    "colorDeprecatedBackgroundWarning": globals["colorScales"]["orange"]["100"],
    "colorDeprecatedBorderWarning": globals["colorScales"]["orange"]["500"],
    "colorDeprecatedIconWarning": globals["colorScales"]["orange"]["400"],
    "colorDeprecatedTextWarning": globals["colorScales"]["orange"]["500"],
    "colorDialogBackgroundPrimary": globals["colorScales"]["white"],
    "colorDialogBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorDialogBackgroundSecondaryUpsell": "linear-gradient(95deg, rgb(from #1A77CA r g b / 0.6) 0%, rgb(from #895ED3 r g b / 0.6) 100%)",
    "colorDialogHelpPanelText": globals["colorScales"]["white"],
    "colorHealthStatusBackgroundExecuting": globals["colorScales"]["blue"]["500"],
    "colorHealthStatusBackgroundFailure": globals["colorScales"]["red"]["500"],
    "colorHealthStatusBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorHealthStatusBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorHealthStatusBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorHealthStatusIconDefault": globals["colorScales"]["white"],
    "colorHealthStatusIconInverse": globals["colorScales"]["slate"]["700"],
    "colorIconDanger": globals["colorScales"]["red"]["500"],
    "colorIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorIconFeature": globals["colorScales"]["purple"]["400"],
    "colorIconInfo": globals["colorScales"]["blue"]["500"],
    "colorIconInversePrimary": globals["colorScales"]["white"],
    "colorIconInverseSecondary": globals["colorScales"]["slate"]["200"],
    "colorIconLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorIconLinkHover": globals["colorScales"]["blue"]["600"],
    "colorIconPrimary": globals["colorScales"]["slate"]["800"],
    "colorIconSecondary": globals["colorScales"]["slate"]["600"],
    "colorIconSelected": globals["colorScales"]["blue"]["600"],
    "colorIconSuccess": globals["colorScales"]["green"]["500"],
    "colorIconTertiary": globals["colorScales"]["slate"]["400"],
    "colorIconWarning": globals["colorScales"]["yellow"]["400"],
    "colorLifecycleBackgroundPrimary": globals["colorScales"]["slate"]["400"],
    "colorLifecycleBorderDefault": globals["colorScales"]["slate"]["600"],
    "colorLifecycleIconPrimary": globals["colorScales"]["white"],
    "colorLifecycleTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorMenuListBackgroundActive": globals["colorScales"]["slate"]["200"],
    "colorMenuListBackgroundDefault": globals["colorScales"]["white"],
    "colorMenuListBackgroundHover": globals["colorScales"]["slate"]["100"],
    "colorMenuListBorderPrimary": globals["colorScales"]["slate"]["200"],
    "colorMenuListIconPrimary": globals["colorScales"]["slate"]["600"],
    "colorMenuListTextHighlight": globals["colorScales"]["blue"]["500"],
    "colorMenuListTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorMenuListTextSecondary": globals["colorScales"]["slate"]["600"],
    "colorNavButtonBackgroundActive": globals["colorScales"]["blue"]["500"],
    "colorNavButtonBackgroundDefault": "rgb(from #1A77CA r g b / 0)",
    "colorNavButtonBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorNavButtonBackgroundPressed": globals["colorScales"]["blue"]["600"],
    "colorNavButtonIconActive": globals["colorScales"]["white"],
    "colorNavButtonIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavButtonIconHover": globals["colorScales"]["white"],
    "colorNavButtonIconPressed": globals["colorScales"]["white"],
    "colorNavListBackgroundActive": globals["colorScales"]["slate"]["100"],
    "colorNavListBackgroundDefault": "rgb(from #1A77CA r g b / 0)",
    "colorNavListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorNavListIconActive": globals["colorScales"]["blue"]["500"],
    "colorNavListIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavListTextActive": globals["colorScales"]["blue"]["500"],
    "colorNavListTextDefault": globals["colorScales"]["slate"]["800"],
    "colorNavListTextHover": globals["colorScales"]["white"],
    "colorNavTabBackgroundActive": "rgb(from #FFFFFF r g b / 0)",
    "colorNavTabBackgroundHover": globals["colorScales"]["white"],
    "colorNavTabBorderPrimary": globals["colorScales"]["blue"]["400"],
    "colorNavTabIconActive": globals["colorScales"]["blue"]["500"],
    "colorNavTabIconDefault": globals["colorScales"]["blue"]["800"],
    "colorNavTabIconHover": globals["colorScales"]["blue"]["500"],
    "colorNavTabTextActive": globals["colorScales"]["blue"]["500"],
    "colorNavTabTextDefault": globals["colorScales"]["blue"]["800"],
    "colorNavTabTextHover": globals["colorScales"]["blue"]["500"],
    "colorOverlayPrimary": "rgb(from #111A23 r g b / 0.56)",
    "colorOverlaySecondary": "rgb(from #000000 r g b / 0.31)",
    "colorPaginationBackgroundActive": globals["colorScales"]["blue"]["500"],
    "colorPaginationBackgroundDefault": globals["colorScales"]["white"],
    "colorPaginationBackgroundDisabled": globals["colorScales"]["white"],
    "colorPaginationBackgroundHover": globals["colorScales"]["slate"]["400"],
    "colorPaginationIconActive": globals["colorScales"]["white"],
    "colorPaginationIconDefault": globals["colorScales"]["slate"]["800"],
    "colorPaginationIconDisabled": globals["colorScales"]["grey"]["400"],
    "colorPaginationIconHover": globals["colorScales"]["white"],
    "colorPaginationTextActive": globals["colorScales"]["white"],
    "colorPaginationTextDefault": globals["colorScales"]["slate"]["800"],
    "colorPaginationTextDisabled": globals["colorScales"]["grey"]["400"],
    "colorPaginationTextHover": globals["colorScales"]["white"],
    "colorParallelChipBackground": globals["colorScales"]["blue"]["500"],
    "colorParallelChipIcon": globals["colorScales"]["white"],
    "colorPopoverBackgroundPrimary": globals["colorScales"]["white"],
    "colorPopoverBackgroundSecondary": globals["colorScales"]["slate"]["100"],
    "colorPopoverInfoCircleBackgroundDefault": globals["colorScales"]["blue"]["200"],
    "colorPopoverInfoCircleBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorPopoverInfoCircleTextDefault": globals["colorScales"]["blue"]["600"],
    "colorPopoverInfoCircleTextHover": globals["colorScales"]["white"],
    "colorPortalCardBackground": globals["colorScales"]["white"],
    "colorPortalCardContentDisabled": globals["colorScales"]["grey"]["500"],
    "colorPortalCardContentText": globals["colorScales"]["grey"]["600"],
    "colorPortalChipBackground": globals["colorScales"]["grey"]["200"],
    "colorPortalLinkTextHover": globals["colorScales"]["blue"]["600"],
    "colorPortalLogoBackground": "transparent",
    "colorPortalPopoverBackground": globals["colorScales"]["white"],
    "colorProcessContainerBackgroundSelected": globals["colorScales"]["blue"]["100"],
    "colorProcessContainerBorderSelected": globals["colorScales"]["blue"]["400"],
    "colorProcessStepBackgroundErrorPrimary": globals["colorScales"]["red"]["100"],
    "colorProcessStepBackgroundErrorSecondary": globals["colorScales"]["red"]["300"],
    "colorProcessStepBackgroundErrorSelected": globals["colorScales"]["red"]["200"],
    "colorProcessStepBackgroundHoverError": globals["colorScales"]["red"]["200"],
    "colorProcessStepBackgroundHoverPrimary": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundHoverSecondary": globals["colorScales"]["blue"]["200"],
    "colorProcessStepBackgroundHoverTertiary": globals["colorScales"]["grey"]["100"],
    "colorProcessStepBackgroundHoverWarning": globals["colorScales"]["orange"]["200"],
    "colorProcessStepBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorProcessStepBackgroundPrimarySelected": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundSecondaryDefault": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundWarningDefault": globals["colorScales"]["orange"]["100"],
    "colorProcessStepBackgroundWarningSecondary": globals["colorScales"]["orange"]["300"],
    "colorProcessStepBackgroundWarningSelected": globals["colorScales"]["orange"]["200"],
    "colorProcessStepBorderDefault": globals["colorScales"]["grey"]["200"],
    "colorProcessStepBorderDisabled": globals["colorScales"]["grey"]["200"],
    "colorProcessStepBorderErrorDefault": globals["colorScales"]["red"]["300"],
    "colorProcessStepBorderErrorHover": globals["colorScales"]["red"]["400"],
    "colorProcessStepBorderErrorSelected": globals["colorScales"]["red"]["500"],
    "colorProcessStepBorderHover": globals["colorScales"]["blue"]["300"],
    "colorProcessStepBorderSelected": globals["colorScales"]["blue"]["400"],
    "colorProcessStepBorderWarningDefault": globals["colorScales"]["orange"]["300"],
    "colorProcessStepBorderWarningHover": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBorderWarningSelected": globals["colorScales"]["orange"]["500"],
    "colorProcessStepIconDefault": globals["colorScales"]["blue"]["500"],
    "colorProcessStepIconErrorPrimary": globals["colorScales"]["red"]["500"],
    "colorProcessStepIconErrorSecondary": globals["colorScales"]["red"]["600"],
    "colorProcessStepIconWarningPrimary": globals["colorScales"]["orange"]["400"],
    "colorProcessStepIconWarningSecondary": globals["colorScales"]["orange"]["500"],
    "colorProcessStepTextDisabled": globals["colorScales"]["grey"]["500"],
    "colorProcessWrapperBackgroundPrimary": globals["colorScales"]["blue"]["100"],
    "colorProcessWrapperBackgroundSecondary": globals["colorScales"]["blue"]["200"],
    "colorProgressBackgroundLinear": globals["colorScales"]["blue"]["200"],
    "colorProgressBackgroundPrimary": globals["colorScales"]["blue"]["500"],
    "colorProgressBackgroundSecondary": globals["colorScales"]["blue"]["200"],
    "colorProgressForegroundCircular": globals["colorScales"]["blue"]["500"],
    "colorProgressForegroundLinear": globals["colorScales"]["blue"]["500"],
    "colorProgressTextInfo": globals["colorScales"]["blue"]["500"],
    "colorScrollbarBackground": "rgb(from #FFFFFF r g b / 0)",
    "colorScrollbarHandle": globals["colorScales"]["grey"]["400"],
    "colorSpaceSwitcherBackgroundDefault": "rgb(from #E1E1E1 r g b / 0.32)",
    "colorSpaceSwitcherBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorSpaceSwitcherBackgroundPressed": globals["colorScales"]["blue"]["500"],
    "colorSpaceSwitcherBorderPrimary": "rgb(from #000000 r g b / 0.16)",
    "colorSpaceSwitcherIconDefault": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherTextDefault": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherTextHover": globals["colorScales"]["white"],
    "colorSpaceSwitcherTextPressed": globals["colorScales"]["white"],
    "colorStatusBadgeBackgroundHealthy": globals["colorScales"]["green"]["500"],
    "colorStatusBadgeBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorStatusBadgeBackgroundUnhealthy": globals["colorScales"]["red"]["500"],
    "colorStatusBadgeBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorStatusBadgeIconDefault": globals["colorScales"]["white"],
    "colorStatusBadgeIconInverse": globals["colorScales"]["slate"]["700"],
    "colorStatusBadgeTextInverse": globals["colorScales"]["slate"]["700"],
    "colorStatusBadgeTextPrimary": globals["colorScales"]["white"],
    "colorSwitchBackgroundOffDefault": globals["colorScales"]["slate"]["300"],
    "colorSwitchBackgroundOffDisabled": globals["colorScales"]["slate"]["200"],
    "colorSwitchBackgroundOnDefault": globals["colorScales"]["blue"]["300"],
    "colorSwitchBackgroundOnDisabled": globals["colorScales"]["blue"]["200"],
    "colorSwitchForegroundOffDefault": globals["colorScales"]["slate"]["100"],
    "colorSwitchForegroundOffDisabled": globals["colorScales"]["slate"]["300"],
    "colorSwitchForegroundOnDefault": globals["colorScales"]["blue"]["500"],
    "colorSwitchForegroundOnDisabled": globals["colorScales"]["blue"]["300"],
    "colorSwitchIconActive": globals["colorScales"]["blue"]["500"],
    "colorSwitchOverlayOff": "rgb(from #B2B9C5 r g b / 0.16)",
    "colorSwitchOverlayOn": "rgb(from #87BFEC r g b / 0.16)",
    "colorTagBackgroundDefault": globals["colorScales"]["blue"]["200"],
    "colorTagBackgroundHover": globals["colorScales"]["blue"]["300"],
    "colorTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFeature": globals["colorScales"]["purple"]["500"],
    "colorTextFieldBorderActive": globals["colorScales"]["blue"]["500"],
    "colorTextFieldBorderDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldBorderDefault": globals["colorScales"]["slate"]["300"],
    "colorTextFieldBorderDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldBorderHover": globals["colorScales"]["slate"]["500"],
    "colorTextFieldIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldIconPrimary": globals["colorScales"]["slate"]["700"],
    "colorTextFieldTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldTextDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorTextFieldTextSecondary": globals["colorScales"]["slate"]["500"],
    "colorTextFieldTextSelected": globals["colorScales"]["blue"]["500"],
    "colorTextInfo": globals["colorScales"]["blue"]["500"],
    "colorTextInversePrimary": globals["colorScales"]["white"],
    "colorTextInverseSecondary": globals["colorScales"]["slate"]["200"],
    "colorTextLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorTextLinkHover": globals["colorScales"]["blue"]["600"],
    "colorTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorTextSecondary": globals["colorScales"]["slate"]["600"],
    "colorTextSelected": globals["colorScales"]["blue"]["500"],
    "colorTextSuccess": globals["colorScales"]["green"]["500"],
    "colorTextTertiary": globals["colorScales"]["slate"]["500"],
    "colorTextWarning": globals["colorScales"]["yellow"]["400"],
    "shadowDrawer": "-4px 0 16px 0 rgba(0,0,0,0.08), -12px 4px 24px -4px rgba(0,0,0,0.1)",
    "shadowExtraSmall": "0 1px 8px 0 rgba(0,0,0,0.02), 0 1px 2px 0 rgba(0,0,0,0.06)",
    "shadowFocused": "0 0 0 1px rgb(26,119,202), 0 0 0 5px rgba(26,119,202,0.32)",
    "shadowFocusedInset": "inset 0 0 0 4px rgba(26,119,202,0.32)",
    "shadowLarge": "0 14px 32px -4px rgba(0,0,0,0.12), 0 2px 6px 0 rgba(0,0,0,0.10)",
    "shadowLayoutPrimary": "-2px -2px 6px 0 rgba(0,0,0,0.06)",
    "shadowMedium": "0 6px 12px 0 rgba(0,0,0,0.1), 0 1px 4px 0 rgba(0,0,0,0.04)",
    "shadowSmall": "0 1px 1px 0 rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.06)"
};